module.exports = __webpack_public_path__ + "static/media/font-size.87634077.svg";